import React from "react";
import { useNavigate } from "react-router-dom";

const FILE = process.env.REACT_APP_API_BASE_URL_FILE;
const resolveImg = (arr) => {
  const im = arr && arr[0] && arr[0].image;
  return im ? (/^https?:\/\//.test(im) ? im : `${FILE}/images/${im}`) : null;
};
const BoxIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round">
    <path d="M3 7l9-4 9 4v10l-9 4-9-4z" /><path d="M3 7l9 4 9-4M12 11v10" />
  </svg>
);

const BasketPopup = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;
  const items = JSON.parse(localStorage.getItem("cart")) || [];
  const total = items.reduce((t, p) => t + (p.totalPrice || 0), 0);
  const go = (p) => { onClose(); navigate(p); };

  return (
    <div className="oot-drawer-ov" onClick={onClose}>
      <div className="oot-drawer" onClick={(e) => e.stopPropagation()}>
        <div className="oot-drawer-head">
          <h3>Your Cart</h3>
          <button className="oot-x" onClick={onClose}>×</button>
        </div>
        <div className="oot-drawer-body">
          {items.length === 0 ? (
            <div className="oot-cart-empty">Your cart is empty.</div>
          ) : (
            items.map((p) => {
              const src = resolveImg(p.images);
              return (
                <div className="oot-cart-row" key={p.id} style={{ padding: "12px 0" }}>
                  <div className="oot-cart-thumb">{src ? <img src={src} alt={p.name} /> : <BoxIcon />}</div>
                  <div className="oot-cart-info">
                    <div className="nm">{p.name}</div>
                    <div className="pr">{p.quantity} × ${p.price}</div>
                  </div>
                  <div className="oot-cart-line">${(p.totalPrice || 0).toFixed(2)}</div>
                </div>
              );
            })
          )}
        </div>
        <div className="oot-drawer-foot">
          <div className="oot-drawer-total"><span>Total</span><span>${total.toFixed(2)}</span></div>
          <button className="oot-btn oot-btn-primary oot-btn-block oot-btn-lg" disabled={!items.length}
            onClick={() => go("/ShoppingCart")}>View cart &amp; checkout</button>
        </div>
      </div>
    </div>
  );
};

export default BasketPopup;
